// extracted by mini-css-extract-plugin
export default {"theme-blue":"theme-blue--H3kHg"};